module.exports = __webpack_public_path__ + "static/media/produtos-ico.a694ab79.svg";